{
  "post-office.team-wolverine.team-wolverine-jira-migration-success.screen-space-flags.cta-link": [
    {
      "type": 0,
      "value": "Go to space"
    }
  ],
  "post-office.team-wolverine.team-wolverine-jira-migration-success.screen-space-flags.description": [
    {
      "type": 0,
      "value": "Your work has been imported and your new space is set up."
    }
  ],
  "post-office.team-wolverine.team-wolverine-jira-migration-success.screen-space-flags.header": [
    {
      "type": 0,
      "value": "Your space is ready"
    }
  ]
}